<template>
	<div class="mt-3">
		<div>该功能已牵至产品管理-生成库存</div>
		<el-button type="primary" @click="gotos('zlgl_cpzl_cpgl')">点击前往</el-button>
	</div>
</template>

<script>
export default {
	data() {
		return {
			
		};
	},
	
	methods: {
		gotos(name){
			this.$router.push({
				name
			});
		}
	}
};
</script>

<style>

</style>
